module.exports = __webpack_public_path__ + "img/doodle_poodle_logo.d510d351.png";